import { Dispatch } from 'react'
import { UseFormReturn } from 'react-hook-form/dist/types'
import { JiraFormFieldTypes } from '../jira-form-field-types'
import { JiraIntegrationForm } from '../jira-form-schema'
import { JiraPageState, updateAnyState } from './jira-integration-page.state'

export interface JiraPageActionArgs {
  dispatch: Dispatch<any>
  formContext: UseFormReturn<JiraIntegrationForm>
  pageState: Partial<JiraPageState>
}

export const resetConnectionState = ({
  dispatch,
  pageState,
  connectionStatus = 'untested'
}: {
  dispatch: Dispatch<any>
  pageState: Partial<JiraPageState>
  connectionStatus?: 'untested' | 'testing'
}) => {
  if (pageState.connectionStatus !== connectionStatus) {
    dispatch(updateAnyState({ connectionStatus }))
  }
}

export const updateManagingCredentials = ({
  dispatch,
  formContext,
  pageState,
  isManagingCredentials
}: JiraPageActionArgs & {
  isManagingCredentials: boolean
}) => {
  const updatedState: Partial<JiraPageState> = {
    isManagingCredentials
  }

  if (isManagingCredentials) {
    const existingCredentialValues = formContext.getValues('credentials')
    if (existingCredentialValues) {
      updatedState.previousDraftCredentials = {
        ...existingCredentialValues
      }
    }
    updatedState.previousDraftCredentialsConnectionStatus =
      pageState.connectionStatus
  }

  dispatch(updateAnyState(updatedState))
}

export const cancelAndRestorePreviousCredentials = ({
  dispatch,
  formContext,
  pageState
}: JiraPageActionArgs) => {
  const { setValue } = formContext
  setValue(
    JiraFormFieldTypes.CREDENTIALS_NAME,
    pageState.previousDraftCredentials?.name ?? ''
  )
  setValue(
    JiraFormFieldTypes.CREDENTIALS_HOST,
    pageState.previousDraftCredentials?.host ?? ''
  )
  setValue(
    JiraFormFieldTypes.CREDENTIALS_USERNAME,
    pageState.previousDraftCredentials?.username ?? ''
  )
  setValue(
    JiraFormFieldTypes.CREDENTIALS_PASSWORD,
    pageState.previousDraftCredentials?.password ?? ''
  )

  dispatch(
    updateAnyState({
      isManagingCredentials: false,
      connectionStatus: pageState.previousDraftCredentialsConnectionStatus
    })
  )
}
